import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../../common/form';

import { getGeneralInfoDummyData } from '../../../../utils/data';
import { MATERIAL_OPTIONS } from '../../../../utils/constants';

import toastService from '../../../../services/toastService';
import _ from 'lodash';

class AUTGIObjectInformationForm extends Form {
	state = {
		data: getGeneralInfoDummyData().objectInformation,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		acceptanceCode: Joi.string().min(3).required().label('Acceptance Code'),
		objectSize: Joi.object({
			label: Joi.alternatives().try(Joi.string(), Joi.number().positive()).required(),
			value: Joi.alternatives().try(Joi.string(), Joi.number().positive()).required(),
			__isNew__: Joi.boolean().optional(),
		}).required().label('Equipment Size'),
		testedWelds: Joi.string().min(3).required().label('Tested Welds'),
		manufactureYear: Joi.number().positive().min(1990).max(new Date().getFullYear()).required().label('Manufacture Year'),
		manufacturingCode: Joi.string().required().label('Manufacturing Code'),
		material: Joi.string().min(3).required().label('Material'),
		couplantUsed: Joi.string().required().label('Couplant Used'),
		nominalThickness: Joi.alternatives().try(Joi.number().positive(), Joi.string().valid('NG')).required().label('Nominal Thickness'),
		calibrationBlock: Joi.string().min(3).required().label('Calibration Block'),
	};

	static propTypes = {
		initialData: PropTypes.object,
		onProceed: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialData) {
			const initialData = { ...this.props.initialData };

			if (initialData.objectSize) {
				if (!_.isObject(initialData.objectSize)) {
					initialData.objectSize = {
						label: initialData.objectSize,
						value: initialData.objectSize,
					}
				} 
			} else {
				initialData.objectSize = {
					label: 'N/A',
					value: 'N/A',
				};
			}

			this.setState({ data: initialData });
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.getApiData());
		toastService.success('Object Information saved successfully!');
	};

	getApiData = () => {
		return {
			...this.state.data,
			objectSize: _.get(this.state.data.objectSize, 'value'),
		}
	};

	getObjectSizes = () => {
		return _.range(5, 105, 0.5).map((size) => ({ label: size, value: size }));
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="form-title">Object Information</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'acceptanceCode',
							label: 'Acceptance Code',
							placeholder: 'Enter Acceptance Code',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'testedWelds',
							label: 'Tested Welds',
							placeholder: 'Enter Tested Welds',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							options: MATERIAL_OPTIONS,
							name: 'material',
							label: 'Material',
							placeholder: 'Select Material',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'couplantUsed',
							label: 'Couplant Used',
							placeholder: 'Enter Couplant Used',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'nominalThickness',
							label: 'Nominal Thickness',
							placeholder: 'Enter Nominal Thickness',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							label: 'Calibration Block',
							name: 'calibrationBlock',
							placeholder: 'Enter Calibration Block',
						})}
					</div>
				</div>
				
				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'manufactureYear',
							label: 'Manufacture Year',
							placeholder: 'Enter Manufacture Year',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'manufacturingCode',
							label: 'Manufacturing Code',
							placeholder: 'Enter Manufacturing Code',
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.getObjectSizes(),
							name: 'objectSize',
							placeholder: 'Select Size',
							label: 'Equipment Size OD (inch)',
							isMulti: false,
						})}
					</div>
				</div>

				<div className="divider mt-4 mb-2 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Object Information')}
				</div>
			</form>
		);
	}
}

export default AUTGIObjectInformationForm;

